require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);


import Swiper from 'swiper/bundle';
import NewsItem from './components/NewsItem'
import MobileHeader from './components/MobileHeader'

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const app = new Vue({
    el: '#app',
    components:{
        NewsItem,
        MobileHeader
    },
    data(){
        return{
            headerActive: false
        }
    },
    methods: {
        menuToggle(){
            this.headerActive = !this.headerActive
            if(this.headerActive === true){
                document.body.style.overflow = 'hidden';
            } else{
                document.body.style.overflow = 'unset';
            }
        }
    },
});

window.addEventListener('scroll',function(){
    const ele = document.getElementById('header');
    const scrollPositionY = window.pageYOffset;
    const bottom = ele.getBoundingClientRect().bottom;
    const mobileHeaderBtn = document.querySelector('.mb_btn');
    if(scrollPositionY > bottom){
        ele.classList.add('header_active');
    } else {
        ele.classList.remove('header_active');
    }
})

const swiper = new Swiper('.home_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 1000,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.home_pagination',
        type: 'bullets',
        clickable: 'true',
    },
    on: {
        beforeInit: function () {
            const swiperImg = document.querySelectorAll('.swiper_bg');
            if (window.innerWidth > 768) {
                swiperImg.forEach(item => {
                    item.style.backgroundImage = `url(${item.dataset.pcImg})`;
                });
            } else {
                swiperImg.forEach(item => {
                    item.style.backgroundImage = `url(${item.dataset.mbImg})`;
                });
            }
        },
    },
});

const swiperApp = new Swiper('.app_swiper', {
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
        760: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        960: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        1060: {
            slidesPerView: 4,
            spaceBetween: 40
        }
    },
    navigation: {
        nextEl: '.app_button_next',
        prevEl: '.app_button_prev',
    },
});

const galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 15,
    slidesPerView: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    // centerInsufficientSlides: true,
    slideToClickedSlide: true
});

const galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    thumbs: {
        swiper: galleryThumbs
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`);
            let nextSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`);
            let prevSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`);  
            if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
                this.thumbs.swiper.slideNext()    
            } else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
                this.thumbs.swiper.slidePrev()    
            }
        }
    }
});